var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.535,
    height: 23.392,
    viewBox: "0 0 19.535 23.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88373",
    "data-name": "Group 88373",
    transform: "translate(-46.736 -42.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M69.72,15.636h-1.2V3.386a1.5,1.5,0,1,1,1.2,0V15.635h0Z",
    transform: "translate(-12.623 49.985)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M2.347,10.091h0A5.67,5.67,0,0,1,0,5.558a5.557,5.557,0,0,1,11.113-.139v.134A5.671,5.671,0,0,1,8.771,10.09L8.3,9.281a4.312,4.312,0,0,0,1.839-3.625,4.547,4.547,0,1,0-7.3,3.606l-.487.828Z",
    transform: "translate(50.939 46.431)",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M4.361,17.6h0A9.457,9.457,0,0,1,0,9.6,9.641,9.641,0,0,1,9.612,0h.036a9.584,9.584,0,0,1,9.24,7.083,9.106,9.106,0,0,1,.291,3.328,9.762,9.762,0,0,1-4.32,7.182l-.483-.821A8.614,8.614,0,1,0,4.709,2.512a8.62,8.62,0,0,0,.14,14.26l-.488.829Z",
    transform: "translate(46.886 42.379)",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastInactive);
export default __webpack_public_path__ + "static/media/broadcast_inactive.08676640.svg";
export { ForwardRef as ReactComponent };